import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const ItemStock = () => {

  const [tab, setTab] = useState("add");
  const [officeType, setOfficeType] = useState(""); 
  const [locations, setLocations] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [tics, setTics] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({
    categoryId: "",
    subCategoryId: "",
    itemId: "",
    purchaseDate: "",
    serialNo: "",
    invoiceNo: ""
  });
  const [stockList, setStockList] = useState([]);
 useEffect(() => {
  loadCategory();
  loadLocationHotel(); 
  loadTIC();
}, []);
  const loadLocationHotel = async (locationId = 0) => {
  const res = await axios.get(
    `${REACT_APP_API_URL}api/item-stock/location-hotel?locationId=${locationId}`
  );
  if (locationId === 0) {
    setLocations(res.data);
  } else {
    setHotels(res.data);
  }
};
  const loadTIC = async () => {
    const res = await axios.get(`${REACT_APP_API_URL}api/request-indent/tic`);
    setTics(res.data || []);
  };
  const loadCategory = async () => {
    const res = await axios.get(`${REACT_APP_API_URL}api/item-stock/category`);
    setCategory(res.data);
  };
  const loadSubCategory = async (id) => {
    const res = await axios.get(`${REACT_APP_API_URL}api/item-stock/subcategory/${id}`);
    setSubCategory(res.data);
  };
  const loadItems = async (subId) => {
    const res = await axios.get(
      `${REACT_APP_API_URL}api/item-stock/items?categoryId=${form.categoryId}&subCategoryId=${subId}`
    );
    setItems(res.data);
  };
  const loadStock = async () => {
  if (!selectedOffice) return alert("Select Office First");
  const res = await axios.get(
    `${REACT_APP_API_URL}api/item-stock/view?officeId=${selectedOffice}&type=${officeType}`
  );

  setStockList(res.data);
};
  const handleSubmit = async () => {
  const serialNo = form.serialNo.trim();
  const invoiceNo = form.invoiceNo.trim();
  if (!officeType) {
    alert("Select Office Type");
    return;
  }
  if (!selectedOffice) {
    alert("Select Office");
    return;
  }
  if (!form.categoryId) {
    alert("Select Category");
    return;
  }
  if (!form.subCategoryId) {
    alert("Select SubCategory");
    return;
  }
  if (!form.itemId) {
    alert("Select Item");
    return;
  }
  if (!form.purchaseDate) {
    alert("Select Purchase Date");
    return;
  }
  const today = new Date().toISOString().split("T")[0];
  if (form.purchaseDate > today) {
    alert("Future date not allowed");
    return;
  }
  if (!serialNo) {
    alert("Serial No is required");
    return;
  }
  if (serialNo.length < 3) {
    alert("Serial No minimum 3 characters");
    return;
  }
  const serialRegex = /^[A-Za-z0-9-]+$/;
  if (!serialRegex.test(serialNo)) {
    alert("Invalid Serial No");
    return;
  }
  if (!invoiceNo) {
    alert("Invoice No is required");
    return;
  }
  if (invoiceNo.length < 3) {
    alert("Invoice No minimum 3 characters");
    return;
  }
  const invoiceRegex = /^[A-Za-z0-9-/]+$/;
  if (!invoiceRegex.test(invoiceNo)) {
    alert("Invalid Invoice No");
    return;
  }
  const scriptRegex = /<script.*?>.*?<\/script>/gi;
  if (scriptRegex.test(serialNo)) {
    alert("Invalid Serial No");
    return;
  }
  if (scriptRegex.test(invoiceNo)) {
    alert("Invalid Invoice No");
    return;
  }
  const duplicate = stockList.some(
    (s) =>
      Number(s.ItemId) === Number(form.itemId) &&
      s.SerialNo?.toLowerCase() === serialNo.toLowerCase()
  );
  if (duplicate) {
    alert("Item with same Serial No already exists");
    return;
  }
  try {
    let payload = {
      action: "A",
      hotelId: officeType === "HOTEL" ? selectedOffice : 0,
      ticId: officeType === "TIC" ? selectedOffice : 0,
      hoId: officeType === "HO" ? 1 : 0,
      items: [
        {
          itemId: Number(form.itemId),
          qty: 1,
          purchaseDate: form.purchaseDate,
          serialNo: serialNo,
          invoiceNo: invoiceNo
        }
      ]
    };
    await axios.post(
      `${REACT_APP_API_URL}api/item-stock/save`,
      payload
    );
    alert("Stock Added Successfully");
    if (tab === "view") {
      loadStock();
    }
    setForm({
      categoryId: "",
      subCategoryId: "",
      itemId: "",
      purchaseDate: "",
      serialNo: "",
      invoiceNo: ""
    });
  } catch (err) {
    console.log(err);
    alert("Something went wrong");
  }
};
  const handleEdit = (data) => {
  setShowModal(true);
  setOfficeType(
    data.HotelId ? "HOTEL" : data.TICId ? "TIC" : "HO"
  );
  setSelectedOffice(
    data.HotelId || data.TICId || 1
  );
  setForm({
    categoryId: data.ItemCategoryId,
    subCategoryId: data.ItemSubCategoryId,
    itemId: data.ItemId,
    purchaseDate: data.PurchaseDate?.split("T")[0],
    serialNo: data.SerialNo,
    invoiceNo: data.InvoiceNo
  });

  loadSubCategory(data.ItemCategoryId);
  loadItems(data.ItemSubCategoryId);
};

  return (
    <div className="container mt-3">
      <h4>Item Stock Entry</h4>
      <div className="mb-3">
        <button
          className={`btn ${tab === "add" ? "btn-primary" : "btn-light"}`}
          onClick={() => setTab("add")}
        >
          Add
        </button>
        <button
          className={`btn ${tab === "view" ? "btn-primary" : "btn-light"} ms-2`}
          onClick={() => setTab("view")}
        >
          View
        </button>
      </div>
      {tab === "add" && (
        <div className="card p-3">
          <div className="row mb-3">
            <div className="col-md-3">
              <label>Office Type</label>
              <select
                className="form-control"
                onChange={(e) => {
                  const val = e.target.value;
                  setOfficeType(val);
                  if (val === "HO") {
                    setSelectedOffice(1); 
                  } else {
                    setSelectedOffice("");
                  }
                }}
              >
                <option value="">Select</option>
                <option value="HOTEL">Hotel</option>
                <option value="TIC">TIC</option>
                <option value="HO">Head Office</option>
              </select>
            </div>
            {officeType === "HOTEL" && (
              <>
                <div className="col-md-3">
                  <label>Location</label>
                  <select
                    className="form-control"
                    onChange={(e) => loadLocationHotel(e.target.value)}
                  >
                    <option>Select</option>
                    {locations.map(l => (
                      <option key={l.LocationId} value={l.LocationId}>
                        {l.LocationName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label>Hotel</label>
                  <select
                    className="form-control"
                    onChange={(e) => setSelectedOffice(e.target.value)}
                  >
                    <option>Select</option>
                    {hotels.map(h => (
                      <option key={h.HotelId} value={h.HotelId}>
                        {h.HotelName}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
            {officeType === "TIC" && (
              <div className="col-md-3">
                <label>TIC</label>
                <select
                  className="form-control"
                  onChange={(e) => setSelectedOffice(e.target.value)}
                >
                  <option>Select</option>
                  {tics.map(t => (
                    <option key={t.intTICId} value={t.intTICId}>
                      {t.vchOfcName}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-md-2">
              <select
                  className="form-control"
                  value={form.categoryId}
                  onChange={(e) => {
                    setForm({
                      ...form,
                      categoryId: e.target.value,
                      subCategoryId: "",
                      itemId: ""
                    });

                    loadSubCategory(e.target.value);
                  }}
                >
                <option>Category</option>
                {category.map(c => (
                  <option key={c.ItemCategoryId} value={c.ItemCategoryId}>
                    {c.ItemCategoryName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <select
                    className="form-control"
                    value={form.subCategoryId}
                    onChange={(e) => {
                      setForm({
                        ...form,
                        subCategoryId: e.target.value,
                        itemId: ""
                      });

                      loadItems(e.target.value);
                    }}
                  >
                <option>SubCategory</option>
                {subCategory.map(s => (
                  <option key={s.ItemSubCategoryId} value={s.ItemSubCategoryId}>
                    {s.ItemSubCategoryName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <select
                  className="form-control"
                  value={form.itemId}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      itemId: e.target.value
                    })
                  }
                >
                <option>Item</option>
                {items.map(i => (
                  <option key={i.ItemId} value={i.ItemId}>
                    {i.ItemName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <input
                type="date"
                className="form-control"
                max={new Date().toISOString().split("T")[0]}
                value={form.purchaseDate}
                onChange={(e) =>
                  setForm({
                    ...form,
                    purchaseDate: e.target.value
                  })
                }
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                placeholder="Serial No"
                className="form-control"
                maxLength={30}
                value={form.serialNo}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z0-9-]*$/.test(value)) {
                    setForm({
                      ...form,
                      serialNo: value
                    });
                  }
                }}
              />
            </div>
            <div className="col-md-2">
              <input
                type="text"
                placeholder="Invoice No"
                className="form-control"
                maxLength={30}
                value={form.invoiceNo}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z0-9-/]*$/.test(value)) {
                    setForm({
                      ...form,
                      invoiceNo: value
                    });
                  }
                }}
              />
            </div>
          </div>
          <div className="mt-3 d-flex gap-2">
            <button className="btn btn-success btn-sm" onClick={handleSubmit}>
              Submit
            </button>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => {
                setForm({
                  categoryId: "",
                  subCategoryId: "",
                  itemId: "",
                  purchaseDate: "",
                  serialNo: "",
                  invoiceNo: ""
                });
                setSelectedOffice("");
              }}
            >
              Reset
            </button>
          </div>

        </div>
      )}
     {tab === "view" && (
  <div className="card p-3">
    <div className="row mb-3">
      <div className="col-md-3">
        <label>Office Type</label>
        <select
          className="form-control"
          value={officeType}
          onChange={(e) => {
            setOfficeType(e.target.value);
            setSelectedOffice("");
          }}
        >
          <option value="">Select</option>
          <option value="HOTEL">Hotel</option>
          <option value="TIC">TIC</option>
          <option value="HO">Head Office</option>
        </select>
      </div>
      {officeType === "HOTEL" && (
        <>
          <div className="col-md-3">
            <label>Location</label>
            <select
              className="form-control"
              onChange={(e) => loadLocationHotel(e.target.value)}
            >
              <option>Select Location</option>
              {locations.map(l => (
                <option key={l.LocationId} value={l.LocationId}>
                  {l.LocationName}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label>Hotel</label>
            <select
              className="form-control"
              onChange={(e) => setSelectedOffice(e.target.value)}
            >
              <option>Select Hotel</option>
              {hotels.map(h => (
                <option key={h.HotelId} value={h.HotelId}>
                  {h.HotelName}
                </option>
              ))}
            </select>
          </div>
        </>
      )}
      {officeType === "TIC" && (
        <div className="col-md-3">
          <label>TIC</label>
          <select
            className="form-control"
            onChange={(e) => setSelectedOffice(e.target.value)}
          >
            <option>Select TIC</option>
            {tics.map(t => (
              <option key={t.intTICId} value={t.intTICId}>
                {t.vchOfcName}
              </option>
            ))}
          </select>
        </div>
      )}
      {officeType === "HO" && (
        <div className="col-md-3">
          <label>Head Office</label>
          <select
            className="form-control"
            onChange={() => setSelectedOffice(1)}
          >
            <option value="1">Head Office</option>
          </select>
        </div>
      )}
      <div className="col-md-2 d-flex align-items-end">
        <button className="btn btn-success w-100" onClick={loadStock}>
          Show
        </button>
      </div>

    </div>
    <table className="table table-bordered">
  <thead>
    <tr>
      <th>#</th>
      <th>Office</th>
      <th>Category</th>
      <th>SubCategory</th>
      <th>Item Name</th>
      <th>Purchase Date</th>
      <th>Serial No</th>
      <th>Invoice No</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {stockList.map((s, i) => (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>{s.Name}</td>
        <td>{s.ItemCategoryName || s.Category}</td>
        <td>{s.ItemSubCategoryName || s.SubCategory}</td>
        <td>{s.ItemName}</td>
        <td>{s.PurchaseDate}</td>
        <td>{s.SerialNo}</td>
        <td>{s.InvoiceNo}</td>
        <td>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleEdit(s)}
          >
            Edit
          </button>
        </td>
      </tr>
    ))}
  </tbody>
</table>
{showModal && (
  <div className="modal show fade d-block" tabIndex="-1">
    <div className="modal-dialog modal-lg">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Edit Item Stock</h5>
          <button className="btn-close" onClick={() => setShowModal(false)}></button>
        </div>

        <div className="modal-body">

          <div className="row">

            <div className="col-md-4">
              <label>Category</label>
              <select className="form-control"
                value={form.categoryId}
                onChange={(e) => {
                  setForm({ ...form, categoryId: e.target.value });
                  loadSubCategory(e.target.value);
                }}>
                <option>Select</option>
                {category.map(c => (
                  <option key={c.ItemCategoryId} value={c.ItemCategoryId}>
                    {c.ItemCategoryName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label>SubCategory</label>
              <select className="form-control"
                value={form.subCategoryId}
                onChange={(e) => {
                  setForm({ ...form, subCategoryId: e.target.value });
                  loadItems(e.target.value);
                }}>
                <option>Select</option>
                {subCategory.map(s => (
                  <option key={s.ItemSubCategoryId} value={s.ItemSubCategoryId}>
                    {s.ItemSubCategoryName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label>Item</label>
              <select className="form-control"
                value={form.itemId}
                onChange={(e) => setForm({ ...form, itemId: e.target.value })}>
                <option>Select</option>
                {items.map(i => (
                  <option key={i.ItemId} value={i.ItemId}>
                    {i.ItemName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4 mt-2">
              <label>Date</label>
              <input type="date" className="form-control"
                value={form.purchaseDate}
                onChange={(e) => setForm({ ...form, purchaseDate: e.target.value })}
              />
            </div>
            <div className="col-md-4 mt-2">
              <label>Serial</label>
              <input type="text" className="form-control"
                value={form.serialNo}
                onChange={(e) => setForm({ ...form, serialNo: e.target.value })}
              />
            </div>
            <div className="col-md-4 mt-2">
              <label>Invoice</label>
              <input type="text" className="form-control"
                value={form.invoiceNo}
                onChange={(e) => setForm({ ...form, invoiceNo: e.target.value })}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary btn-sm"
            onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button className="btn btn-success btn-sm"
            onClick={() => {
              handleSubmit();
              setShowModal(false);
            }}>
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
)}

  </div>
)}

    </div>
  );
};

export default ItemStock;